/* ==========================================================================
   GROUNDED PRINTS — Social Sticker Builder engine
   Live preview (canvas) + variant mapping + product-form wiring.
   No cart-intercept, no fake prices: Color+Size map to a REAL variant id.
   ========================================================================== */
(function () {
  'use strict';

  var COLOR_HEX = { 'White': '#ffffff', 'Black': '#111111', 'Red': '#e8232b' };

  // Inline SVG paths so canvas drawing never depends on async <img> loads.
  // Each icon is normalized to a 24x24 viewBox.
  var ICONS = {
    instagram: ['M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16M12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63c-.79.31-1.46.72-2.12 1.38C1.36 2.67.95 3.34.63 4.14.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.31.8.72 1.47 1.38 2.13.66.66 1.33 1.07 2.12 1.38.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56a5.86 5.86 0 0 0 2.13-1.38 5.86 5.86 0 0 0 1.38-2.13c.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.86 5.86 0 0 0-1.38-2.12A5.86 5.86 0 0 0 19.86.63c-.76-.3-1.64-.5-2.91-.56C15.67.01 15.26 0 12 0z', 'M12 5.84A6.16 6.16 0 1 0 18.16 12 6.16 6.16 0 0 0 12 5.84zm0 10.16A4 4 0 1 1 16 12a4 4 0 0 1-4 4z', 'M18.41 4.15a1.44 1.44 0 1 0 1.44 1.44 1.44 1.44 0 0 0-1.44-1.44z'],
    x: ['M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z'],
    tiktok: ['M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z'],
    youtube: ['M23.5 6.2a3.02 3.02 0 0 0-2.12-2.14C19.5 3.55 12 3.55 12 3.55s-7.5 0-9.38.51A3.02 3.02 0 0 0 .5 6.2 31.5 31.5 0 0 0 0 12a31.5 31.5 0 0 0 .5 5.8 3.02 3.02 0 0 0 2.12 2.14c1.88.51 9.38.51 9.38.51s7.5 0 9.38-.51a3.02 3.02 0 0 0 2.12-2.14A31.5 31.5 0 0 0 24 12a31.5 31.5 0 0 0-.5-5.8zM9.55 15.57V8.43L15.82 12z'],
    snapchat: ['M12.03 2.05c.34 0 2.97.03 4.36 2.41.62 1.07.49 2.94.39 4.46l-.01.1c-.02.18 0 .3.05.39.06.1.2.18.36.21.27.05.74-.02 1.32-.27.18-.08.4-.08.57.01.2.1.32.29.32.5.01.27-.18.5-.74.73-.07.03-.16.06-.27.1-.4.13-1 .33-1.16.71-.09.2-.05.46.1.76l.01.01c.05.1 1.2 2.43 3.46 2.81.18.03.31.19.3.37 0 .06-.02.12-.04.18-.16.37-.83.64-2.05.83-.04.06-.08.27-.11.41-.03.13-.06.27-.1.41-.05.18-.18.27-.37.27h-.03c-.13 0-.31-.03-.55-.08-.31-.07-.7-.14-1.18-.14-.28 0-.58.02-.88.07-.59.1-1.09.46-1.67.87-.82.59-1.75 1.25-3.17 1.25l-.13-.01-.11.01c-1.42 0-2.35-.66-3.17-1.25-.58-.41-1.08-.77-1.67-.87-.3-.05-.6-.07-.88-.07-.5 0-.9.08-1.18.14-.22.05-.41.08-.55.08-.24 0-.36-.13-.4-.27-.04-.14-.07-.28-.1-.41-.03-.14-.07-.35-.11-.41-1.22-.19-1.89-.46-2.05-.83a.43.43 0 0 1-.04-.18.37.37 0 0 1 .3-.37c2.26-.38 3.41-2.71 3.46-2.81l.01-.01c.15-.3.19-.56.1-.76-.16-.38-.76-.58-1.16-.71-.11-.04-.2-.07-.27-.1-.74-.29-.8-.59-.73-.79.1-.27.46-.43.74-.43.08 0 .15.01.21.04.51.24.96.35 1.32.35.4 0 .57-.13.63-.21.05-.09.07-.21.05-.39l-.01-.1c-.1-1.52-.23-3.39.39-4.46C9.04 2.08 11.67 2.05 12.03 2.05z'],
    at: ['M12 2a10 10 0 1 0 5 18.66l-1-1.73A8 8 0 1 1 20 12v.9a1.6 1.6 0 0 1-3.2 0V7.5h-1.8v1.06A4.5 4.5 0 1 0 16 16.1a3.4 3.4 0 0 0 6-2.2V12A10 10 0 0 0 12 2zm0 12.7A2.7 2.7 0 1 1 14.7 12 2.7 2.7 0 0 1 12 14.7z']
  };

  function drawIcon(ctx, name, x, y, size, color) {
    if (name === 'none') return;
    var paths = ICONS[name];
    if (!paths) return;
    ctx.save();
    ctx.translate(x, y);
    ctx.scale(size / 24, size / 24);
    ctx.fillStyle = color;
    for (var i = 0; i < paths.length; i++) {
      ctx.fill(new Path2D(paths[i]));
    }
    ctx.restore();
  }

  function SocialBuilder(el) {
    this.el = el;
    this.canvas = el.querySelector('[data-canvas]');
    this.ctx = this.canvas.getContext('2d');
    this.usernameInput = el.querySelector('[data-username]');
    this.counter = el.querySelector('[data-counter]');
    this.dimReadout = el.querySelector('[data-dim-readout]');
    this.priceEl = el.querySelector('[data-price]');
    this.qtyInput = el.querySelector('[data-qty]');
    this.sizesWrap = el.querySelector('[data-sizes]');

    try { this.variants = JSON.parse(el.dataset.variants || '[]'); } catch (e) { this.variants = []; }
    try { this.optionNames = JSON.parse(el.dataset.optionNames || '[]'); } catch (e) { this.optionNames = []; }
    this.moneyFormat = el.dataset.moneyFormat || '${{amount}}';

    // Figure out which option index is Color and which is Size.
    this.colorIdx = this.findOption(['color', 'colour']);
    this.sizeIdx = this.findOption(['size', 'width']);

    this.state = {
      username: '',
      icon: 'instagram',
      font: 'americancaptain',
      color: 'White',
      size: null
    };

    this.buildSizes();
    this.bind();
    this.fontsReady = false;
    this.ensureFonts();
    this.syncVariant();
    this.render();
  }

  SocialBuilder.prototype.findOption = function (keywords) {
    for (var i = 0; i < this.optionNames.length; i++) {
      var n = (this.optionNames[i] || '').toLowerCase();
      for (var k = 0; k < keywords.length; k++) {
        if (n.indexOf(keywords[k]) !== -1) return i;
      }
    }
    return -1;
  };

  // Unique size values from variants (preserving variant order).
  SocialBuilder.prototype.sizeValues = function () {
    if (this.sizeIdx < 0) return [];
    var seen = {}, out = [];
    this.variants.forEach(function (v) {
      var val = v.options[this.sizeIdx];
      if (val != null && !seen[val]) { seen[val] = 1; out.push(val); }
    }, this);
    return out;
  };

  SocialBuilder.prototype.buildSizes = function () {
    var sizes = this.sizeValues();
    if (!sizes.length) { this.sizesWrap.style.display = 'none'; return; }
    this.state.size = sizes[0];
    var self = this;
    sizes.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gp-sb__tile' + (i === 0 ? ' is-selected' : '');
      b.setAttribute('data-size', s);
      b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      b.textContent = s;
      b.addEventListener('click', function () {
        self.select(self.sizesWrap, b);
        self.state.size = s;
        self.syncVariant();
      });
      self.sizesWrap.appendChild(b);
    });
  };

  SocialBuilder.prototype.select = function (group, btn) {
    group.querySelectorAll('button').forEach(function (b) {
      b.classList.remove('is-selected');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');
  };

  SocialBuilder.prototype.bind = function () {
    var self = this;

    this.usernameInput.addEventListener('input', function () {
      self.state.username = self.usernameInput.value;
      var max = parseInt(self.usernameInput.getAttribute('maxlength'), 10) || 22;
      var left = max - self.usernameInput.value.length;
      self.counter.textContent = left + ' characters left';
      self.render();
      self.writeProps();
    });

    this.el.querySelector('[data-icons]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-icon]'); if (!b) return;
      self.select(this, b);
      self.state.icon = b.dataset.icon;
      self.render(); self.writeProps();
    });

    this.el.querySelector('[data-fonts]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-font]'); if (!b) return;
      self.select(this, b);
      self.state.font = b.dataset.font;
      self.render(); self.writeProps();
    });

    this.el.querySelector('[data-colors]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-color]'); if (!b) return;
      self.select(this, b);
      self.state.color = b.dataset.color;
      var nameEl = self.el.querySelector('[data-color-name]');
      if (nameEl) nameEl.textContent = b.dataset.color;
      self.syncVariant();
      self.render(); self.writeProps();
    });

    var minus = this.el.querySelector('[data-qty-minus]');
    var plus = this.el.querySelector('[data-qty-plus]');
    minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(self.qtyInput.value, 10) || 1) - 1);
      self.qtyInput.value = v; self.syncQty();
    });
    plus.addEventListener('click', function () {
      var v = (parseInt(self.qtyInput.value, 10) || 1) + 1;
      self.qtyInput.value = v; self.syncQty();
    });
    this.qtyInput.addEventListener('input', function () { self.syncQty(); });
  };

  // Match the variant for the current Color + Size.
  SocialBuilder.prototype.matchVariant = function () {
    var self = this;
    return this.variants.find(function (v) {
      var okColor = self.colorIdx < 0 || v.options[self.colorIdx] === self.state.color;
      var okSize = self.sizeIdx < 0 || v.options[self.sizeIdx] === self.state.size;
      return okColor && okSize;
    });
  };

  SocialBuilder.prototype.formatMoney = function (cents) {
    var amount = (cents / 100);
    var fmt = this.moneyFormat;
    function withCommas(n, dec) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    if (/\{\{\s*amount_no_decimals\s*\}\}/.test(fmt)) {
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas(amount, 0));
    }
    if (/\{\{\s*amount\s*\}\}/.test(fmt)) {
      return fmt.replace(/\{\{\s*amount\s*\}\}/, withCommas(amount, 2));
    }
    return '$' + withCommas(amount, 2);
  };

  // Find the real product form (in buy-buttons-upload) and set name="id".
  SocialBuilder.prototype.getForm = function () {
    var section = this.el.closest('.shopify-section') || document;
    return section.querySelector('form[action*="/cart/add"]') ||
           section.querySelector('product-form-component form') ||
           document.querySelector('form[action*="/cart/add"]');
  };

  SocialBuilder.prototype.syncVariant = function () {
    var v = this.matchVariant();
    var form = this.getForm();
    if (v) {
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = v.id;
      }
      this.priceEl.textContent = this.formatMoney(v.price * (parseInt(this.qtyInput.value, 10) || 1));
      this.priceEl.classList.toggle('gp-sb__sold-out', !v.available);
    } else {
      this.priceEl.textContent = '—';
    }
    this.currentVariant = v;
  };

  SocialBuilder.prototype.syncQty = function () {
    var qty = Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
    var form = this.getForm();
    if (form) {
      var q = form.querySelector('input[name="quantity"]');
      if (q) q.value = qty;
    }
    if (this.currentVariant) {
      this.priceEl.textContent = this.formatMoney(this.currentVariant.price * qty);
    }
  };

  // Write builder choices as line-item properties on the real form.
  SocialBuilder.prototype.writeProps = function () {
    var form = this.getForm();
    if (!form) return;
    var self = this;
    function setProp(name, value) {
      var input = form.querySelector('input[data-gp-prop="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.setAttribute('data-gp-prop', name);
        input.name = 'properties[' + name + ']';
        form.appendChild(input);
      }
      input.value = value;
    }
    var fontLabelEl = self.el.querySelector('[data-font="' + self.state.font + '"]');
    setProp('Username', self.state.username);
    setProp('Social Icon', self.iconLabel(self.state.icon));
    setProp('Font', fontLabelEl ? fontLabelEl.textContent.trim() : self.state.font);
    // Color & Size are real variant options, no need to duplicate, but include for clarity on the order.
    setProp('_builder', 'social-v1');
    // Preview image (PNG data URL) -> a hidden prop the order can reference.
    try { setProp('_Preview', self.canvas.toDataURL('image/png')); } catch (e) {}
  };

  SocialBuilder.prototype.iconLabel = function (key) {
    var map = { instagram: 'Instagram', tiktok: 'TikTok', x: 'X', snapchat: 'Snapchat', youtube: 'YouTube', at: '@ symbol only', none: 'No icon' };
    return map[key] || key;
  };

  // Load the uploaded fonts via FontFace so the canvas can use them.
  SocialBuilder.prototype.ensureFonts = function () {
    if (window.__gpFontsLoaded) { this.fontsReady = true; return; }
    var base = this.el.dataset.fontsBase || '';
    var defs = [
      ['gpf-americancaptain', 'gp-americancaptain.woff2'],
      ['gpf-bebasneue', 'gp-bebasneue.woff2'],
      ['gpf-coolvetica', 'gp-coolvetica.woff2'],
      ['gpf-santana', 'gp-santana.woff2'],
      ['gpf-vampirewars', 'gp-vampirewars.woff2'],
      ['gpf-dragonslayer', 'gp-dragonslayer.woff2'],
      ['gpf-oldlondon', 'gp-oldlondon.woff2'],
      ['gpf-meltedmonster', 'gp-meltedmonster.woff2'],
      ['gpf-frizquadrata', 'gp-frizquadrata.woff2'],
      ['gpf-komikax', 'gp-komikax.woff2']
    ];
    var self = this;
    var promises = [];
    if (!window.FontFace) { this.fontsReady = true; return; }
    defs.forEach(function (d) {
      try {
        var ff = new FontFace(d[0], 'url(' + base + d[1] + ')');
        promises.push(ff.load().then(function (loaded) {
          document.fonts.add(loaded);
        }).catch(function () {}));
      } catch (e) {}
    });
    window.__gpFontsLoaded = true;
    Promise.all(promises).then(function () {
      self.fontsReady = true;
      self.render();
    });
  };

  SocialBuilder.prototype.fontFamily = function () {
    return "'gpf-" + this.state.font + "', sans-serif";
  };

  SocialBuilder.prototype.render = function () {
    var ctx = this.ctx, c = this.canvas;
    var W = c.width, H = c.height;
    ctx.clearRect(0, 0, W, H);

    var color = COLOR_HEX[this.state.color] || '#111111';
    // Preview backdrop so light colors (e.g. White) are visible. This is a
    // PREVIEW surface only — the actual decal is die-cut with no background.
    // White -> dark surface; Black/Red -> light surface.
    var lightDesign = (this.state.color === 'White');
    ctx.fillStyle = lightDesign ? '#3a3a3a' : '#f1f1f1';
    ctx.fillRect(0, 0, W, H);
    var text = (this.state.username || 'yourusername');
    var hasIcon = this.state.icon !== 'none';
    var pad = W * 0.05;
    var family = this.fontFamily();
    var self = this;

    ctx.textAlign = 'left';
    ctx.textBaseline = 'alphabetic';

    // Measure the REAL rendered height of the text (cap height of the actual
    // glyphs in the chosen font) so the icon can match it exactly, like the
    // real die-cut sticker where the logo and lettering are the same height.
    function measure(fontPx) {
      ctx.font = fontPx + 'px ' + family;
      var m = ctx.measureText(text);
      var asc = (m.actualBoundingBoxAscent != null) ? m.actualBoundingBoxAscent : fontPx * 0.7;
      var desc = (m.actualBoundingBoxDescent != null) ? m.actualBoundingBoxDescent : fontPx * 0.2;
      return { w: m.width, asc: asc, desc: desc, h: asc + desc };
    }

    // Start from a generous size, then scale to fit the canvas box.
    var targetH = H * 0.46;          // visual height budget for the glyph block
    var fontPx = H * 0.6;
    var m = measure(fontPx);
    // Scale so the text height equals targetH.
    if (m.h > 0) { fontPx = fontPx * (targetH / m.h); m = measure(fontPx); }

    // Icon is a square sized slightly larger than the text cap-height so it
    // reads like the finished die-cut sticker (logo a touch bigger than caps).
    var ICON_SCALE = 1.12; // slightly bigger than cap-height
    var GAP_RATIO = 0.08;  // tight gap so logo nearly touches the first letter
    var iconSize = hasIcon ? m.asc * ICON_SCALE : 0;
    var gap = hasIcon ? m.asc * GAP_RATIO : 0;

    // Width fit: shrink everything together if it overflows.
    var maxW = W - pad * 2;
    var totalW = iconSize + gap + m.w;
    if (totalW > maxW && totalW > 0) {
      var k = maxW / totalW;
      fontPx *= k;
      m = measure(fontPx);
      iconSize = hasIcon ? m.asc * ICON_SCALE : 0;
      gap = hasIcon ? m.asc * GAP_RATIO : 0;
      totalW = iconSize + gap + m.w;
    }

    // Shared baseline: center the glyph block vertically.
    var startX = (W - totalW) / 2;
    var baseline = (H + m.asc) / 2; // bottom of the caps
    var textX = startX + iconSize + gap;

    if (hasIcon) {
      if (this.state.icon === 'at') {
        // The "@ only" option renders a real typographic @ in Bebas Neue,
        // sized to the username's cap-height and sitting on the shared
        // baseline so it reads like part of the lettering (not a clunky icon).
        ctx.save();
        ctx.fillStyle = color;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        // Find a Bebas font size whose cap-height matches the username caps.
        var atPx = fontPx;
        ctx.font = atPx + 'px gpf-bebasneue';
        var am = ctx.measureText('@');
        var atAsc = (am.actualBoundingBoxAscent != null) ? am.actualBoundingBoxAscent : atPx * 0.7;
        if (atAsc > 0) {
          atPx = atPx * ((m.asc * ICON_SCALE) / atAsc);
          ctx.font = atPx + 'px gpf-bebasneue';
        }
        ctx.fillText('@', startX, baseline);
        ctx.restore();
      } else {
        // Vertically CENTER the icon on the optical middle of the capital letters
        // (the cap band runs from baseline-m.asc to baseline). The icon's own
        // center is placed at that midpoint so it lines up with the first letter.
        var capMid = baseline - (m.asc / 2);
        var iconTop = capMid - (iconSize / 2);
        drawIcon(ctx, this.state.icon, startX, iconTop, iconSize, color);
      }
    }
    ctx.globalAlpha = this.state.username ? 1 : 0.4;
    ctx.fillStyle = color;
    ctx.font = fontPx + 'px ' + family;
    ctx.fillText(text, textX, baseline);
    ctx.globalAlpha = 1;

    if (this.dimReadout) {
      this.dimReadout.textContent = (this.state.size ? this.state.size + ' wide · ' : '') + 'preview only (die-cut, no background)';
    }
  };

  function init() {
    document.querySelectorAll('social-sticker-builder').forEach(function (el) {
      if (el.__gpInit) return;
      el.__gpInit = true;
      try { new SocialBuilder(el); } catch (e) { /* fail silent, native form still works */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
